export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string, search: string = '') {
  const current = getCurrentUrl(pathname);

  if (!current || !url) return false;

  if (search && current + search === `/${url}`) return true;

  if (current === url || (!search && (current.startsWith(url + '/') || current.startsWith(url + '?')))) {
    return true;
  }

  return false;
}

